export const MONTEVIDEO_TIME_ZONE = "America/Montevideo";

const toDate = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? new Date() : date;
};

const formatter = (options) => new Intl.DateTimeFormat("es-UY", {
  timeZone: MONTEVIDEO_TIME_ZONE,
  ...options,
});

export const formatMontevideoDate = (value) =>
  formatter({ day: "2-digit", month: "2-digit", year: "numeric" }).format(toDate(value));

export const formatMontevideoTime = (value) =>
  formatter({ hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(toDate(value));

export const formatMontevideoDateTime = (value) =>
  formatter({
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(toDate(value));

export const montevideoDayKey = (value) => {
  const parts = formatter({ day: "2-digit", month: "2-digit", year: "numeric" })
    .formatToParts(toDate(value))
    .reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const isSameMontevideoDay = (left, right) =>
  montevideoDayKey(left) === montevideoDayKey(right);
